import React from "react";
import { ToastContainer } from "react-toastify";

const PaymentMethodTab = ({
  paymentMethods,
  paymentMethodInput,
  setPaymentMethodInput,
  handleAddPaymentMethod,
  showModal,
  setShowModal,
  selectedItem,
  setSelectedItem,
  handleConfirmDelete,
}) => {
  const paymentOptions = [
    "Google Pay",
    "Paytm",
    "PhonePe",
    "Credit Card",
    "Debit Card",
  ];

  return (
    <>
    <ToastContainer/>

    <div className="space-y-6 montserrat-font-1">
      {/* Add */}
      <div className="bg-white border rounded-xl p-6 shadow-sm montserrat-font-1">
        <h2 className="text-green-600 font-semibold mb-4">
          Add Payment Method
        </h2>

        <div className="flex flex-col md:flex-row gap-3">
          <select
            value={paymentMethodInput}
            onChange={(e) => setPaymentMethodInput(e.target.value)}
            className="flex-1 border rounded-md px-3 py-2 text-sm bg-white"
          >
            <option value="">Select Payment Method</option>

            {paymentOptions.map((method) => (
              <option key={method} value={method}>
                {method}
              </option>
            ))}
          </select>

          <button
            onClick={handleAddPaymentMethod}
            disabled={!paymentMethodInput}
            className={`px-4 py-2 rounded-md text-white ${
              paymentMethodInput
                ? "bg-green-600"
                : "bg-gray-400 cursor-not-allowed"
            }`}
          >
            Add Method
          </button>
        </div>
      </div>

      {/* List */}
      <div className="space-y-4 montserrat-font-1">
        {paymentMethods?.map((item, index) => (
          <div
            key={item.id || index}
            className="bg-white border rounded-xl p-5"
          >
            <div className="flex justify-between items-center mb-3">
              <h2 className="text-green-600 font-semibold">{item.method}</h2>

              <button
                onClick={() => {
                  setSelectedItem(item);
                  setShowModal(true);
                }}
                className="bg-red-500 text-white px-3 py-1 rounded-md"
              >
                Remove
              </button>
            </div>

            <div className="border-t pt-3 text-sm space-y-2">
              <div className="flex justify-between">
                <span className="text-gray-500">Payment Method:</span>
                <span className="font-medium">{item.method}</span>
              </div>

              <div className="flex justify-between items-center">
                <span className="text-gray-500">Status:</span>

                <span
                  className={`px-2 py-1 text-xs rounded-full font-medium ${
                    item.status === "active"
                      ? "bg-green-100 text-green-700"
                      : "bg-red-100 text-red-700"
                  }`}
                >
                  {item.status}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 flex justify-center items-center montserrat-font-1 bg-black/40">
          <div className="bg-white p-6 rounded-xl w-[350px] montserrat-font-1">
            <h2 className="text-red-600 font-semibold mb-3">Confirm Delete</h2>

            <p className="mb-4 text-sm montserrat-font-2">
              Delete this payment method?
            </p>

            <div className="mb-4">{selectedItem?.method}</div>

            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowModal(false)}
                className="bg-gray-500 text-white px-3 py-1 rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmDelete}
                className="bg-red-500 text-white px-3 py-1 rounded"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default PaymentMethodTab;
